export default "__VITE_ASSET__qGPdoi5k__";